module.exports = __webpack_public_path__ + "static/media/prev.e9f57ca0.svg";